var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-container",
    {
      staticStyle: {
        height: "100vh",
        width: "100vw",
        background: "#f0f2f5；overflow:hidden",
      },
    },
    [
      [
        _c(
          "el-container",
          [
            _c("el-header", [
              _c("div", { staticClass: "header-left header-card" }, [
                _c("div", { staticClass: "header-logo-platform" }, [
                  _c("img", {
                    staticClass: "logo-wrapper",
                    attrs: {
                      alt: "",
                      src: require("../assets/images/float/logo@2x.png"),
                    },
                  }),
                ]),
                _c("div", { staticClass: "platform-list-wrapper" }, [
                  _vm.getAuthAgent && _vm.getAuthAgent.includes("2")
                    ? _c(
                        "div",
                        {
                          staticClass: "platform-list-wrapper__item",
                          class: { active: _vm.headerMenuActive === "2-1" },
                          on: {
                            click: function ($event) {
                              return _vm.handleSelect("2-1")
                            },
                          },
                        },
                        [
                          _c("iconSvg", {
                            staticClass: "icon-info",
                            attrs: {
                              iconClass:
                                _vm.headerMenuActive === "2-1"
                                  ? "icondianpufuwu-gaoliang"
                                  : "icondianpufuwu-moren",
                            },
                          }),
                          _c("span", { staticClass: "sys-name" }, [
                            _vm._v(_vm._s(_vm.$t("system::common::店铺服务"))),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.getAuthAgent && _vm.getAuthAgent.includes("3")
                    ? _c(
                        "div",
                        {
                          staticClass: "platform-list-wrapper__item",
                          class: { active: _vm.headerMenuActive === "2-2" },
                          on: {
                            click: function ($event) {
                              return _vm.handleSelect("2-2")
                            },
                          },
                        },
                        [
                          _c("iconSvg", {
                            staticClass: "icon-info",
                            attrs: {
                              iconClass:
                                _vm.headerMenuActive === "2-2"
                                  ? "iconjingyingfenxi2-gaoliang"
                                  : "iconjingyingfenxi-moren",
                            },
                          }),
                          _c("span", { staticClass: "sys-name" }, [
                            _vm._v(_vm._s(_vm.$t("system::common::经营分析"))),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.getAuthAgent && _vm.getAuthAgent.includes("5")
                    ? _c(
                        "div",
                        {
                          staticClass: "platform-list-wrapper__item",
                          class: { active: _vm.headerMenuActive === "2-3" },
                          on: {
                            click: function ($event) {
                              return _vm.handleSelect("2-3")
                            },
                          },
                        },
                        [
                          _c("iconSvg", {
                            staticClass: "icon-info",
                            attrs: {
                              iconClass:
                                _vm.headerMenuActive === "2-3"
                                  ? "iconERP-gaoliang"
                                  : "iconERP-moren",
                            },
                          }),
                          _c("span", { staticClass: "sys-name" }, [
                            _vm._v(_vm._s(_vm.$t("system::common::ERP系统"))),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                ]),
              ]),
              _c(
                "div",
                { staticClass: "header-right header-card" },
                [
                  _c("span", { staticClass: "timeArea" }, [
                    _vm._v("(GMT+08:00) 北京"),
                  ]),
                  _c("div", { staticClass: "icon-item__wrap" }, [
                    _c(
                      "div",
                      {
                        staticClass: "icon-item",
                        on: {
                          click: function ($event) {
                            return _vm.handlePreviewLink("docs")
                          },
                        },
                      },
                      [
                        _c("i", {
                          staticClass: "icon-svg iconfont iconbangzhuzhongxin",
                        }),
                        _vm._v(" 帮助 "),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "icon-item",
                        on: {
                          mouseenter: function ($event) {
                            _vm.messageShow = true
                          },
                          mouseleave: function ($event) {
                            _vm.messageShow = false
                          },
                        },
                      },
                      [
                        _c("i", {
                          staticClass: "icon-svg iconfont iconxiaoxi1",
                        }),
                        _vm._v(" 消息 "),
                        _vm.unread > 0
                          ? _c("span", { staticClass: "unread-num one-line" }, [
                              _vm._v(
                                _vm._s(_vm.unread > 99 ? "99+" : _vm.unread)
                              ),
                            ])
                          : _vm._e(),
                        _c(
                          "transition",
                          { attrs: { name: "fade-in-linear" } },
                          [
                            _c("Message", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.messageShow,
                                  expression: "messageShow",
                                },
                              ],
                              staticClass: "message-popop",
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "icon-item", on: { click: _vm.openKefu } },
                      [
                        _c("i", { staticClass: "icon-svg iconfont iconkefu" }),
                        _vm._v(" 客服 "),
                      ]
                    ),
                  ]),
                  _vm.merchantShopOptions.length > 1 || _vm.preAccount
                    ? _c(
                        "el-dropdown",
                        {
                          staticClass: "index--merchantSelect",
                          on: {
                            command: _vm.onselectMerchantId,
                            "visible-change": _vm.showDropdown,
                          },
                        },
                        [
                          _c("span", [
                            _c("i", {
                              staticClass:
                                "icon-svg iconfont iconqiye1 icon-qiye",
                            }),
                          ]),
                          _c(
                            "el-dropdown-menu",
                            {
                              staticClass: "index--merchantSelect__menu",
                              attrs: { slot: "dropdown" },
                              slot: "dropdown",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "index--merchantSelect__menuTitle",
                                },
                                [
                                  _c("span", [
                                    _c("img", {
                                      attrs: {
                                        src: require("../assets/images/icon-qiye.png"),
                                      },
                                    }),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            "user-guidance::data::my_company"
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]),
                                  _c(
                                    "span",
                                    { staticStyle: { color: "#999" } },
                                    [
                                      _c("i", {
                                        staticClass: "iconfont icona-15shezhi",
                                        on: {
                                          click: function ($event) {
                                            return _vm.$router.push(
                                              "/enterprise-manager"
                                            )
                                          },
                                        },
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._l(
                                _vm.merchantShopOptions.filter(function (item) {
                                  return item.isDisplay
                                }),
                                function (item) {
                                  return _c(
                                    "el-dropdown-item",
                                    {
                                      key: item.userId,
                                      staticClass:
                                        "index--merchantSelect__menuItem",
                                      style:
                                        _vm.merchantId === item.userId
                                          ? "color: #0560fd"
                                          : "",
                                      attrs: { command: item.userId },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "index--merchantSelect__itemName",
                                        },
                                        [_vm._v(_vm._s(item.userName))]
                                      ),
                                      _vm.merchantId === item.userId
                                        ? _c("i", {
                                            staticClass: "el-icon-check",
                                          })
                                        : item.messageNum
                                        ? _c("el-badge", {
                                            staticClass: "badge",
                                            attrs: {
                                              max: 99,
                                              value: item.messageNum,
                                            },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  )
                                }
                              ),
                            ],
                            2
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c("img", {
                    staticClass: "user-icon",
                    attrs: {
                      src: require("../assets/images/icon_head@2x.png"),
                    },
                  }),
                  _c(
                    "el-dropdown",
                    {
                      attrs: { "show-timeout": 0 },
                      on: { command: _vm.handleCommand },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "user-container" },
                        [
                          _c("icon-svg", {
                            staticClass: "down-icon",
                            attrs: { iconClass: "icona-10xiala1" },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-dropdown-menu",
                        {
                          staticClass: "custom-dropdown",
                          staticStyle: { padding: "22px 0 15px" },
                          attrs: { slot: "dropdown" },
                          slot: "dropdown",
                        },
                        [
                          _c("div", { staticClass: "drop-wrap" }, [
                            _c("img", {
                              staticClass: "account-icon",
                              attrs: {
                                src: require("../assets/images/icon_head@2x.png"),
                              },
                            }),
                            _c("div", { staticClass: "account-wrap" }, [
                              _c("p", { staticClass: "login-name one-line" }, [
                                _vm._v(_vm._s(_vm.userInfo.loginName)),
                              ]),
                              _vm.userInfo.phone &&
                              _vm.userInfo.phone !== _vm.userInfo.loginName
                                ? _c("p", { staticClass: "phone" }, [
                                    _vm._v(
                                      " " + _vm._s(_vm.userInfo.phone) + " "
                                    ),
                                  ])
                                : _vm._e(),
                            ]),
                          ]),
                          _c(
                            "el-dropdown-item",
                            { attrs: { command: "personal" } },
                            [
                              _c(
                                "div",
                                { staticClass: "edit-drop__item" },
                                [
                                  _c("icon-svg", {
                                    staticClass: "drop-icon",
                                    attrs: { iconClass: "icongerenzhongxin1" },
                                  }),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("system::common::btn::个人中心")
                                      ) +
                                      " "
                                  ),
                                ],
                                1
                              ),
                            ]
                          ),
                          _c(
                            "el-dropdown-item",
                            { attrs: { command: "changePwd" } },
                            [
                              _c(
                                "div",
                                { staticClass: "edit-drop__item" },
                                [
                                  _c("icon-svg", {
                                    staticClass: "drop-icon",
                                    attrs: { iconClass: "iconmima" },
                                  }),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("system::common::btn::修改密码")
                                      ) +
                                      " "
                                  ),
                                ],
                                1
                              ),
                            ]
                          ),
                          _c(
                            "el-dropdown-item",
                            { attrs: { command: "logout" } },
                            [
                              _c(
                                "div",
                                { staticClass: "edit-drop__item" },
                                [
                                  _c("icon-svg", {
                                    staticClass: "drop-icon",
                                    attrs: { iconClass: "icontuichu1" },
                                  }),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("system::common::btn::logout")
                                      ) +
                                      " "
                                  ),
                                ],
                                1
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            !_vm.changeMerchantIdVisible
              ? [
                  _c(
                    "el-main",
                    { staticClass: "content-js main-content-flex" },
                    [
                      _c("bindModal", {
                        on: {
                          close: _vm.closeBindModal,
                          show: _vm.showBindModal,
                        },
                        model: {
                          value: _vm.bindShopModalShow,
                          callback: function ($$v) {
                            _vm.bindShopModalShow = $$v
                          },
                          expression: "bindShopModalShow",
                        },
                      }),
                      _c("welcomeModal", {
                        on: { bindShop: _vm.showBindModal },
                      }),
                      _vm.$route.name !== "expired"
                        ? _c("menu-side", {
                            attrs: {
                              param: {
                                only: false,
                                list: [
                                  "contract-manager",
                                  "account-manager",
                                  "personal-message",
                                ],
                              },
                            },
                          })
                        : _vm._e(),
                      _c(
                        "div",
                        { staticClass: "layout-main-content" },
                        [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.routerList.length,
                                  expression: "routerList.length",
                                },
                              ],
                              staticClass: "tabs-headerBar",
                            },
                            [
                              _c("div", { staticClass: "tab-bar-box" }, [
                                _c(
                                  "ul",
                                  { staticClass: "tab-bar" },
                                  [
                                    _c(
                                      "ScrollsBar",
                                      {
                                        ref: "scroll",
                                        staticStyle: {
                                          "padding-bottom": "9px",
                                        },
                                        attrs: { vertical: false },
                                      },
                                      _vm._l(_vm.routerList, function (item) {
                                        return _c(
                                          "li",
                                          {
                                            key: item.url,
                                            class: {
                                              "tab-bar-item": true,
                                              active:
                                                Object.keys(_vm.curTab.query)
                                                  .length &&
                                                (_vm.curTab.name ===
                                                  "data-board" ||
                                                  _vm.curTab.name ===
                                                    "iframe-board")
                                                  ? _vm.curTab.fullPath ===
                                                    String(item.fullPath)
                                                  : _vm.curTab.name ===
                                                    item.name,
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.clickTab(item)
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "text" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    item.uniName ||
                                                      item.meta.name ||
                                                      item.name
                                                  )
                                                ),
                                              ]
                                            ),
                                            _c("i", {
                                              staticClass: "el-icon-close",
                                              on: {
                                                click: function ($event) {
                                                  $event.stopPropagation()
                                                  return _vm.removeTab(item)
                                                },
                                              },
                                            }),
                                          ]
                                        )
                                      }),
                                      0
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                            ]
                          ),
                          _c(
                            "ScrollsBar",
                            {
                              ref: "boardShowWrap",
                              staticClass: "custom-scroll-wrap",
                              attrs: { id: "boardShowWrap" },
                            },
                            [
                              [
                                _c(
                                  "el-container",
                                  {
                                    class: [
                                      "router-wrapper",
                                      _vm.isCustomBi ? "clearPadding" : "",
                                      _vm.routerList.length
                                        ? ""
                                        : "cell-nobig-padding",
                                    ],
                                  },
                                  [
                                    _vm.noTitlePage
                                      ? [
                                          _c("div", [
                                            _vm.localBackName
                                              ? _c(
                                                  "div",
                                                  {
                                                    ref: "back",
                                                    staticClass:
                                                      "comm-back-wrap mb-16",
                                                    on: { click: _vm.onBack },
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "iconfont iconarrow-up",
                                                    }),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "backText",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "system::common::btn::back"
                                                              )
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]),
                                        ]
                                      : _vm._e(),
                                    _vm.$route.name !== "expired"
                                      ? _c(
                                          "span",
                                          {
                                            staticClass: "menu-toggle-wrap",
                                            class: [
                                              _vm.menu.collapse
                                                ? "fold "
                                                : "unfold",
                                            ],
                                            on: { click: _vm.toggleMenu },
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "menu-toggle iconfont icondown-circle-01",
                                            }),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm.visiable
                                      ? [
                                          _c(
                                            "keep-alive",
                                            [
                                              _vm.$route.meta.keepAlive
                                                ? _c("router-view", {
                                                    key: _vm.$route.name,
                                                    staticClass: "router-box",
                                                  })
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                          !_vm.$route.meta.keepAlive
                                            ? _c("router-view", {
                                                staticClass: "router-box",
                                              })
                                            : _vm._e(),
                                        ]
                                      : _vm._e(),
                                  ],
                                  2
                                ),
                              ],
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              : [
                  _c("div", { staticClass: "change-merchat-box" }, [
                    _vm._v(
                      _vm._s(_vm.$t("system::common::正在为您切换主体")) + ".."
                    ),
                  ]),
                ],
          ],
          2
        ),
        _c(
          "el-dialog",
          {
            attrs: {
              "append-to-body": true,
              "close-on-click-modal": false,
              visible: _vm.showLanguage,
              width: "500px",
            },
            on: {
              "update:visible": function ($event) {
                _vm.showLanguage = $event
              },
            },
          },
          [
            _c("span", { attrs: { slot: "title" }, slot: "title" }, [
              _vm._v(
                _vm._s(_vm.$t("system::common::btn::change_system_language"))
              ),
            ]),
            _c("div", { staticClass: "language-dialog" }, [
              _c(
                "div",
                [
                  _c("p", [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "system::common::btn::select_change_language_holder"
                        )
                      )
                    ),
                  ]),
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "250px", margin: "10px 0px" },
                      attrs: {
                        placeholder: _vm.$t(
                          "system::common::select_placeholder"
                        ),
                      },
                      model: {
                        value: _vm.language,
                        callback: function ($$v) {
                          _vm.language = $$v
                        },
                        expression: "language",
                      },
                    },
                    _vm._l(_vm.options, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.showLanguage = false
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("system::common::btn::cancel")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.changeLanguage },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("system::common::btn::confirm")) +
                          " "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]),
          ]
        ),
        _c("changePwdDialog", {
          model: {
            value: _vm.showChangePwd,
            callback: function ($$v) {
              _vm.showChangePwd = $$v
            },
            expression: "showChangePwd",
          },
        }),
      ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }